module.exports = __webpack_public_path__ + "img/Dantam Hair 59.cf78de19.jpg";